exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.skiplink {\r\n    position: absolute;\r\n    clip: rect(1px, 1px, 1px, 1px);\r\n    padding: 0;\r\n    border: 0;\r\n    height: 1px;\r\n    width: 1px;\r\n    overflow: hidden;\r\n}\r\na.skiplink:focus {\r\n    clip: auto;\r\n    height: auto;\r\n    width: auto;\r\n    background-color: #fff;\r\n    padding: 0.3em;\r\n}\r\n#map:focus {\r\n    outline: #4A74A8 solid 0.15em;\r\n}", ""]);

// exports
